import firebase from './initializeFirebase';
export default firebase;
export let FirebaseAppsEnum = /*#__PURE__*/function (FirebaseAppsEnum) {
  FirebaseAppsEnum[FirebaseAppsEnum["GTIDev"] = 0] = "GTIDev";
  FirebaseAppsEnum[FirebaseAppsEnum["GTIMessagingDev"] = 1] = "GTIMessagingDev";
  return FirebaseAppsEnum;
}({});
export { sendNotifications, sendNotificationsAsAdmin } from './notification';